<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#a)">
      <path
        fill="#B2B2B2"
        d="M9.174 18.563v1.414c0 .603.196 1.19.558 1.673l.012.017a2.79 2.79 0 0 0 2.23 1.114h.007a2.791 2.791 0 0 0 2.79-2.788v-1.43H9.174Z"
      />
      <path
        fill="currentColor"
        d="M17.612 12.469a5.625 5.625 0 1 0-8.84 4.61.937.937 0 0 1 .402.769v.714a.469.469 0 0 0 .47.47h4.687a.469.469 0 0 0 .468-.47v-.715a.938.938 0 0 1 .402-.77 5.604 5.604 0 0 0 2.41-4.608Z"
      />
      <path
        fill="#FFFBEB"
        d="M11.987 10.594a5.625 5.625 0 0 1 5.297 3.75 5.625 5.625 0 1 0-10.594 0 5.625 5.625 0 0 1 5.297-3.75Z"
      />
      <path
        stroke="#191919"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M13.406 22.781h-2.812M14.344 20.906H9.656M12 1.219V4.03M4.045 4.514l1.989 1.989M19.955 4.514l-1.989 1.989M1.219 12.469H4.03M22.781 12.469H19.97M17.625 12.469a5.625 5.625 0 1 0-8.84 4.61.937.937 0 0 1 .402.769v.714a.469.469 0 0 0 .47.47h4.687a.469.469 0 0 0 .469-.47v-.715a.938.938 0 0 1 .402-.77 5.606 5.606 0 0 0 2.41-4.608Z"
      />
    </g>
  </svg>
</template>
